import React, { useState, useEffect } from "react";
import { APILINK } from "../../EndPoint";
import ErrorHandler from "../../error-handler/ErrorHandler";
import {
  Container,
  Row,
  Col,
  Tooltip,
  OverlayTrigger,
  Modal,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Button } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import { Pagination, Spin } from "antd";
import DataTable from "react-data-table-component";
import {
  checkSignature,
  getSignatureDetails,
  getSignatures,
} from "../../api/signtureRequests";
import axiosInstance from "../../api/axiosInstance";
import Checker from "../layout/form/Checker";
import { Select, Image } from "antd";
import { useLanguageContext } from "../contexts/LanguageContext";

function CheckSignature() {
  const {language} = useLanguageContext()
  const { t } = useTranslation();

  const [columns, setCoulmns] = useState([
    {
      name: `${t("scanCheck.signee")}`,
      selector: (row) => row?.[`signee_name_${language}`],
      sortable: true,
      right: true,
    },
    {
      name: `${t("scanCheck.bank")}`,
      selector: (row) => row?.bank[`name_${language}`],
      sortable: true,
      right: true,
    },
    {
      name: `${t("scanCheck.branch")}`,
      selector: (row) => row?.bank_branch[`name_${language}`],
      sortable: true,
      right: true,
    },
    {
      name: `${t("scanCheck.category")}`,
      selector: (row) => row?.category[`title_${language}`],
      sortable: true,
      right: true,
    },
    {
      name: `${t("requestType")}`,
      selector: (row) => row?.request_type,
      sortable: true,
      right: true,
    },
    {
      name: `${t("scanCheck.job")}`,
      selector: (row) => row?.job.title_en,
      sortable: true,
      right: true,
    },
  ]);
  const [details, setDetails] = useState();
  const [signature, setSignature] = useState("");

  function onSelect(id) {
    getSignatureDetails(id).then((res) => {
      console.log(res);
      setSignature(res);
    });
  }
  return (
    <Checker
      columns={columns}
      dataFunction={getSignatures}
      checkFunction={checkSignature}
      onSelect={onSelect}
    >
      <Container className="p-4">
        <Row>
          <Col className="text-center" sm={12}>
            {" "}
            <h2 className="signature-title">{t("searchTable.sigLabel")}</h2>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <div className="signature-data">
              <p>
                <strong className="label">{t("name")} : </strong>
                {signature ? signature.data.signee_name_en : null}
              </p>
            </div>
            <div className="signature-data">
              <p>
                <strong className="label">
                  {t("searchTable.category")} :{" "}
                </strong>
                {signature ? signature.data.category.title_en : null}
              </p>
            </div>
            <div className="signature-data">
              <div className='privilageDiv'>
                <div className='privilageLabel'>
                <p>
                  <strong className="label">
                    {t("searchTable.privileges")} :
                  </strong>
                  </p>
                </div>
                <div className='privilageValue'>
                  {" "}
                  <p>
                  {signature ? signature.data.category.privs_en : null}
                  </p>
                </div>
              </div>
            </div>
            <div className="signature-data">
              <p>
                {" "}
                <strong className="label">{t("searchTable.job")} : </strong>
                {signature ? signature.data.job.title_en : null}
              </p>
            </div>
          </Col>
          <Col lg={6}>
            <div>
              <p>
                {" "}
                <strong className="label">{t("searchTable.bank")} : </strong>
                {signature ? signature.data.bank.name_en : null}
              </p>
            </div>
            <div>
              <p>
                <strong className="label">{t("searchTable.branch")} : </strong>{" "}
                {signature ? signature.data.bank_branch.name_en : null}
              </p>
            </div>
            <div className="sigImage">
              <Image src={signature ? signature.image : null} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={6}></Col>
          <Col lg={6}></Col>
        </Row>
        <Row>
          <Col lg={12}></Col>
        </Row>
      </Container>
    </Checker>
  );
}

export default ErrorHandler(CheckSignature, axiosInstance);
